import React, { useState } from "react";
import { Dropdown } from "primereact/dropdown";
import LPActivityReport from "./LPActivityReport";
import WeeklyReportDownload from "./WeeklyReportDownload";
import "./Reports.css";

const reportTypes = [
  { label: "LP Creation & Activity Report", value: "activity" },
  { label: "LP Classification Report", value: "weekly" },
];

const Report = () => {
  const [reportType, setReportType] = useState("activity");

  return (
    <div className="reports-page">
      <div className="report-page-heading">
        <h2>Reports</h2>
        <p>Generate and download LPGen reports</p>
      </div>

      <div className="report-type-field" >
        <label htmlFor="reportType" className="font-bold block mb-2">
          Report Type
        </label>
        <Dropdown
          inputId="reportType"
          value={reportType}
          options={reportTypes}
          optionLabel="label"
          optionValue="value"
          onChange={(e) => setReportType(e.value)}
          placeholder="Select report type"
          className="report-type-dropdown"
        />
      </div>

      {reportType === "activity" ? (
        <LPActivityReport />
      ) : (
        <WeeklyReportDownload />
      )}
    </div>
  );
};

export default Report;
